export const PermissionConstant = {
  FILE_MANAGEMENT_VIEW: "dp.twin.file.library.view",
  FILE_MANAGEMENT_DELETE: "dp.twin.file.library.delete",
  FILE_MANAGEMENT_UPLOAD: "dp.twin.file.library.upload",
  ISO_FILE_MANAGEMENT_DELETE: "dp.twin.iso.library.delete",
  ISO_FILE_MANAGEMENT_UPLOAD: "dp.twin.iso.library.upload",
  ISO_FILE_MANAGEMENT_VIEW: "dp.twin.iso.library.view",
  ISO_FILE_MANAGEMENT_DOWNLOAD: "dp.twin.iso.library.download",
  COURSE_LIBRARY_VIEW: "dp.twin.course.library.view",
};
